export default "__VITE_ASSET__DbxJ0OU7__";